// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "dddb54ceb3f16c6c75ee67f35081c111d0b3657f/static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"440":"486bdddc","581":"0843d95a","688":"2b6b0509","774":"772e6540"}[chunkId] + ".chunk.js";
};